import { formatDescription } from '../../helpers/product-helpers';

export const generateBundleInformationTitle = (brandName, productLabel, modelNumber, props) => {
  const { pageNumber, pageTitle } = props || {};
  const parts = [
    brandName,
    productLabel,
    modelNumber,
    pageNumber ? `| Pg${pageNumber}` : null
  ].filter(Boolean);
  const defaultTitle = parts.join(' ');
  return pageTitle?.trim() || `${defaultTitle} - The Home Depot`;
};

export const getBundleInformationDescription = (product, props) => {
  const { details, seo } = product || {};
  const { description: detailsDescription } = details || {};
  const { seoDescription } = seo || {};
  const { pageDescription } = props || {};
  const defaultDescription = formatDescription(seoDescription || detailsDescription);
  return pageDescription || defaultDescription;
};
